import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

const SRX_LOGO_SVG = `<svg width="76" height="28" viewBox="0 0 76 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.7581 1.06025C14.1618 0.827434 14.5998 0.701047 15.0651 0.754263C17.0564 0.980428 14.5998 3.92058 14.2508 4.41283C12.9575 6.25541 11.7121 8.13126 10.583 10.067C9.75503 11.4838 9.13233 12.8807 8.84493 14.5038C8.75597 14.9961 8.70123 15.5016 8.78335 15.9872C8.86546 16.4728 9.11865 16.9584 9.53606 17.2444C10.2614 17.73 11.192 17.5571 11.9995 17.4107C13.6965 17.0981 15.4414 16.7987 17.1727 16.8519C17.7201 16.8719 18.5276 16.8786 18.9518 17.2777C19.0408 17.3641 19.0887 17.444 19.1434 17.5504C19.6498 18.5748 18.4044 19.6524 17.6585 20.118C16.4473 20.8697 15.0377 21.2289 13.6555 21.5748C12.2732 21.9207 10.7472 22.2001 9.26919 22.3731C7.56532 22.5726 5.82039 22.7057 4.09599 22.7057C2.00892 22.7057 0.742987 21.0294 1.04407 19.087C1.3999 16.8054 3.0285 14.7898 4.28075 12.8874C5.73143 10.679 7.27107 8.53703 8.88599 6.44167C9.69345 5.39731 10.5146 4.35961 11.411 3.38178C12.0269 2.70328 12.8001 1.59906 13.7444 1.0536L13.7581 1.06025Z" fill="#1671A3" stroke="#1468AA" stroke-width="0.5" stroke-miterlimit="10"/>
<path d="M6.87227 25.4536C6.44117 25.2474 6.09218 24.9481 5.89374 24.5091C5.11365 22.7263 9.05514 23.2585 9.69152 23.2851C11.9291 23.3782 14.1736 23.4115 16.4181 23.325C18.0877 23.2585 19.641 23.039 21.2081 22.4204C21.6802 22.2341 22.1524 22.0146 22.5424 21.6886C22.9325 21.3627 23.2199 20.9037 23.2472 20.4048C23.2951 19.5467 22.6451 18.8682 22.0908 18.2829C20.9275 17.0456 19.7368 15.7618 18.8746 14.2983C18.6009 13.8394 18.1835 13.1609 18.3067 12.6021C18.3341 12.4824 18.382 12.3959 18.4435 12.2961C19.0662 11.3382 20.6675 11.7972 21.4681 12.1697C22.7614 12.7751 23.822 13.7462 24.8485 14.7041C25.8749 15.662 26.9287 16.7729 27.8593 17.9037C28.9336 19.2075 29.9669 20.5778 30.877 22.0013C31.9787 23.7241 31.1781 25.6532 29.3237 26.4248C27.1408 27.3295 24.52 27.0501 22.2003 27.0168C19.511 26.9836 16.8218 26.8439 14.1394 26.6111C12.6476 26.4847 11.1012 26.325 9.60941 26.0523C8.82248 25.906 7.70709 25.8395 6.87227 25.4403V25.4536Z" fill="#5B8B3E" stroke="#58873E" stroke-width="0.5" stroke-miterlimit="10"/>
<path d="M11.6356 11.735C11.1292 13.0787 10.8487 14.5887 12.183 15.5133C13.1068 16.1519 14.4822 16.245 15.3376 15.4468C16.583 14.2893 15.9534 12.4468 16.6788 11.0632C17.411 9.67955 19.0738 9.37356 20.5313 9.6729C21.6946 9.91237 22.4541 10.8836 23.2274 11.6751C25.9645 14.4889 28.6469 17.3559 31.3841 20.1697C31.5757 20.3692 31.9794 20.6153 32.2736 20.5156C33.0195 20.2628 32.6363 18.979 32.3831 18.5333C29.6597 13.7771 26.3888 9.28709 22.5363 5.32919C21.7151 4.48439 20.8666 3.67285 20.0181 2.86132C19.4228 2.28925 18.7385 1.6041 17.8284 1.67727C16.8704 1.75044 16.2545 2.52207 15.8234 3.28039C14.5096 5.58861 13.2573 8.01657 12.1762 10.4445C12.0051 10.8303 11.7998 11.2694 11.6287 11.7283L11.6356 11.735Z" fill="#214598" stroke="#333889" stroke-width="0.5" stroke-miterlimit="10"/>
<path d="M71.8295 20.3745L69.2389 16.5882L66.9562 20.3745H63.4417L67.5178 14.0875L63.3511 8.01172H66.9562L69.5106 11.7452L71.757 8.01172H75.2716L71.2317 14.246L75.4346 20.3745H71.8295Z" fill="#0734A9"/>
<path d="M58.6985 20.3745L56.0535 15.7076H55.3108V20.3745H52.2129V8.01172H57.4123C58.4147 8.01172 59.2662 8.18196 59.9667 8.52243C60.6792 8.86291 61.2106 9.33253 61.5609 9.9313C61.9111 10.5183 62.0863 11.1758 62.0863 11.9037C62.0863 12.7255 61.8447 13.4593 61.3616 14.1051C60.8906 14.7508 60.1901 15.2087 59.2601 15.4787L62.195 20.3745H58.6985ZM55.3108 13.5767H57.2311C57.7987 13.5767 58.2215 13.4417 58.4992 13.1717C58.7891 12.9017 58.934 12.5201 58.934 12.027C58.934 11.5574 58.7891 11.1875 58.4992 10.9175C58.2215 10.6475 57.7987 10.5125 57.2311 10.5125H55.3108V13.5767Z" fill="#0734A9"/>
<path d="M45.6758 20.4981C44.7458 20.4981 43.9125 20.3514 43.1757 20.0578C42.439 19.7643 41.8472 19.3299 41.4003 18.7546C40.9655 18.1794 40.7361 17.4867 40.7119 16.6766H44.0091C44.0574 17.1345 44.2204 17.4867 44.4982 17.7332C44.776 17.968 45.1383 18.0854 45.5852 18.0854C46.0441 18.0854 46.4065 17.9856 46.6722 17.7861C46.9379 17.5747 47.0707 17.2871 47.0707 16.9231C47.0707 16.6179 46.962 16.3654 46.7446 16.1659C46.5393 15.9663 46.2797 15.8019 45.9656 15.6728C45.6637 15.5436 45.2289 15.3969 44.6613 15.2325C43.84 14.9859 43.1697 14.7394 42.6504 14.4928C42.131 14.2463 41.6842 13.8823 41.3098 13.401C40.9353 12.9196 40.7481 12.2915 40.7481 11.5166C40.7481 10.366 41.1769 9.46787 42.0344 8.82214C42.8919 8.16467 44.0091 7.83594 45.3859 7.83594C46.7869 7.83594 47.9162 8.16467 48.7737 8.82214C49.6312 9.46787 50.0901 10.3719 50.1505 11.5342H46.799C46.7748 11.135 46.6239 10.8239 46.3461 10.6008C46.0683 10.366 45.712 10.2486 45.2772 10.2486C44.9028 10.2486 44.6009 10.3484 44.3714 10.548C44.1419 10.7359 44.0272 11.0118 44.0272 11.3757C44.0272 11.7749 44.2204 12.086 44.6069 12.3091C44.9934 12.5322 45.5973 12.7728 46.4185 13.0311C47.2398 13.3012 47.9041 13.5595 48.4113 13.806C48.9307 14.0526 49.3775 14.4106 49.7519 14.8803C50.1263 15.3499 50.3135 15.9545 50.3135 16.6942C50.3135 17.3986 50.1263 18.0385 49.7519 18.6138C49.3896 19.189 48.8582 19.6469 48.1577 19.9874C47.4572 20.3279 46.6299 20.4981 45.6758 20.4981Z" fill="#0734A9"/>
</svg>`;

function svgToBase64(svgString: string, width: number, height: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = width * 2;
      canvas.height = height * 2;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }
      resolve(canvas.toDataURL("image/png"));
      URL.revokeObjectURL(url);
    };
    img.onerror = reject;
    img.src = url;
  });
}

function getOrdinalSuffix(day: number): string {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

interface TemperatureLogPDFOptions {
  reportData: any[];
  selectedMonth: Date;
  temperatureUnit: string;
  clientCode: string;
  refrigeratorName: string;
}

export async function generateTemperatureLogPDF(options: TemperatureLogPDFOptions): Promise<jsPDF> {
  const { reportData, selectedMonth, temperatureUnit, clientCode, refrigeratorName } = options;

  const doc = new jsPDF("portrait", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;

  // Add SRX logo
  try {
    const logoBase64 = await svgToBase64(SRX_LOGO_SVG, 76, 28);
    doc.addImage(logoBase64, "PNG", margin, 10, 30, 11);
  } catch {
    doc.setFontSize(10);
    doc.setTextColor(7, 52, 169);
    doc.setFont("helvetica", "bold");
    doc.text("S R X", margin, 18);
  }

  // Title
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Temperature Log Report", pageWidth / 2, 14, { align: "center" });
  doc.setFontSize(11);
  doc.text(moment(selectedMonth).format("MMMM YYYY"), pageWidth / 2, 20, { align: "center" });

  // Client code (left) and Refrigerator name (right)
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text(clientCode?.toUpperCase() || "", margin, 32);
  doc.text(refrigeratorName?.toUpperCase() || "", pageWidth - margin, 32, { align: "right" });

  // Build data by day
  const daysInMonth = moment(selectedMonth).daysInMonth();
  const dataByDay: Record<number, { min: number | null; max: number | null; avg: number | null }> = {};

  reportData?.forEach((log: any) => {
    if (!log.sensorLogDateTime) return;
    const day = moment(log.sensorLogDateTime).date();
    dataByDay[day] = {
      min: log.min != null ? Number(log.min) : null,
      max: log.max != null ? Number(log.max) : null,
      avg: log.avg != null ? Number(log.avg) : null,
    };
  });

  // Build table rows (16 rows: left = 1st-16th, right = 17th-31st)
  const formatTemp = (val: number | null | undefined): string => {
    if (val == null) return "";
    return `${val.toFixed(2)} ${temperatureUnit}`;
  };

  const tableBody: string[][] = [];
  for (let i = 1; i <= 16; i++) {
    const leftDay = i;
    const rightDay = i + 16;
    const leftData = dataByDay[leftDay];
    const rightData = rightDay <= daysInMonth ? dataByDay[rightDay] : undefined;

    tableBody.push([
      `${leftDay}${getOrdinalSuffix(leftDay)}`,
      formatTemp(leftData?.min),
      formatTemp(leftData?.max),
      formatTemp(leftData?.avg),
      "", // gap column
      rightDay <= daysInMonth ? `${rightDay}${getOrdinalSuffix(rightDay)}` : "",
      rightDay <= daysInMonth ? formatTemp(rightData?.min) : "",
      rightDay <= daysInMonth ? formatTemp(rightData?.max) : "",
      rightDay <= daysInMonth ? formatTemp(rightData?.avg) : "",
    ]);
  }

  // Draw table
  autoTable(doc, {
    startY: 36,
    head: [["DATE", "MIN", "MAX", "AVG", "", "DATE", "MIN", "MAX", "AVG"]],
    body: tableBody,
    theme: "grid",
    styles: {
      fontSize: 8,
      cellPadding: 3,
      lineColor: [200, 200, 200],
      lineWidth: 0.3,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [245, 245, 245],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
      lineColor: [200, 200, 200],
    },
    columnStyles: {
      0: { halign: "center", fontStyle: "bold", cellWidth: 18 },
      1: { halign: "center", cellWidth: 22 },
      2: { halign: "center", cellWidth: 22 },
      3: { halign: "center", cellWidth: 22 },
      4: { cellWidth: 6, fillColor: [255, 255, 255], lineWidth: 0 },
      5: { halign: "center", fontStyle: "bold", cellWidth: 18 },
      6: { halign: "center", cellWidth: 22 },
      7: { halign: "center", cellWidth: 22 },
      8: { halign: "center", cellWidth: 22 },
    },
    margin: { left: margin, right: margin },
    didParseCell: (data) => {
      // Remove borders for gap column
      if (data.column.index === 4) {
        data.cell.styles.lineWidth = 0;
      }
    },
  });

  // Footer
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(100, 100, 100);
  doc.text(
    `report created - ${moment().format("MM/DD/YYYY hh:mm A")}`,
    pageWidth - margin,
    pageHeight - 10,
    { align: "right" }
  );

  return doc;
}

export function downloadTemperatureLogPDF(doc: jsPDF, clientCode: string): void {
  const filename = `SRX_TemperatureLog_${clientCode?.toUpperCase() || ""}_${moment().format("YYYYMMDD_HHmmssSSS")}.pdf`;
  doc.save(filename);
}

export function openTemperatureLogPDF(doc: jsPDF): void {
  const pdfBlob = doc.output("blob");
  const url = URL.createObjectURL(pdfBlob);
  window.open(url, "_blank", "noopener,noreferrer");
}
